import { Card, CardContent, Typography } from "@mui/material"



import { GestaoVagaChipIngresso } from "./GestaoVagaOcupacao"
import GestaoVagaCidadeDistancia from "./GestaoVagaCidadeDistancia.jsx"

import { resolverIngressoVaga, vagaTemIngressoDisponivel } from "./gestaoVagaIngressoMock.js"



export default function GestaoVagaListaCard({
	vaga,
	onAbrir,
	urgenteHoje = false,
	onAtualizarLocalizacao,
	atualizandoLocalizacao = false,
}) {

	const ingresso = resolverIngressoVaga(vaga)

	const temDisponivel = vagaTemIngressoDisponivel(vaga)



	return (

		<Card className={`gv-card${urgenteHoje ? " gv-card--urgente" : ""}`} variant="outlined">

			<CardContent className="pb-2">

				{urgenteHoje ? (
					<span className="gv-card__badge-urgente">Urgente — vaga hoje</span>
				) : null}

				<Typography variant="subtitle1" className="font-semibold text-[#100940]">

					{vaga.titulo || "Vaga sem título"}

				</Typography>

				{vaga.descricaoResumo ? (

					<Typography variant="body2" color="text.secondary" className="mt-1">

						{vaga.descricaoResumo}

					</Typography>

				) : null}

				{vaga.valorPreferencia ? (

					<Typography variant="body2" className="mt-2 text-emerald-700">

						<strong>Expectativa:</strong> {vaga.valorPreferencia}

					</Typography>

				) : null}

				{vaga.cidadeEstado || vaga.distanciaTexto || onAtualizarLocalizacao ? (
					<GestaoVagaCidadeDistancia
						className="mt-2 mb-1"
						cidadeEstado={vaga.cidadeEstado}
						distanciaTexto={vaga.distanciaTexto}
						onAtualizarLocalizacao={onAtualizarLocalizacao}
						atualizandoLocalizacao={atualizandoLocalizacao}
					/>
				) : null}

				<div className="gv-card__chip-row">

					<GestaoVagaChipIngresso ingresso={ingresso} />

				</div>

				{ingresso?.janelaDias ? (

					<Typography variant="caption" color="text.secondary" className="block mt-1">

						Janela: {ingresso.janelaDias} dias · até {ingresso.limitePorDia} por dia

					</Typography>

				) : null}

				{temDisponivel ? (

					<Typography variant="caption" className="block mt-2 text-emerald-700 font-medium">

						Você ainda pode ingressar nesta vaga

					</Typography>

				) : null}

			</CardContent>

			<div className="gv-card__footer">

				<button

					type="button"

					className="btnFullW gv-card__btn-detalhes"

					onClick={() => onAbrir(vaga.id)}

				>

					Ver detalhes

				</button>

			</div>

		</Card>

	)

}


